import { useQuery } from '@tanstack/react-query';
import formatCurrency from 'syf-js-utilities/formats/formatCurrency';
import { useActivityContext } from '../context/activity-store';
import { trendsQuery, trendsQueryCacheKey } from '../helpers/spending-trends/trends-query';
var useSpendingTrends = function (enabled, statementDate) {
    var _a, _b;
    var _c = useActivityContext(), accountId = _c.accountId, accountIdType = _c.accountIdType, config = _c.config;
    var _d = useQuery({
        queryKey: trendsQueryCacheKey({
            accountId: accountId,
            accountIdType: accountIdType,
            statementDate: statementDate
        }),
        queryFn: trendsQuery({
            accountId: accountId,
            accountIdType: accountIdType,
            config: config,
            statementDate: statementDate
        }),
        enabled: enabled
    }), data = _d.data, isError = _d.isError, isLoading = _d.isLoading, isSuccess = _d.isSuccess;
    var formattedTotalAmount = formatCurrency(((_b = (_a = data === null || data === void 0 ? void 0 : data.spendings) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.totalAmount) || 0);
    return {
        data: data,
        formattedTotalAmount: formattedTotalAmount,
        isError: isError,
        isLoading: isLoading,
        isSuccess: isSuccess
    };
};
export default useSpendingTrends;
//# sourceMappingURL=use-spending-trends.js.map